<template>
  <div>
    <!-- 新增信息 -->
    <i-modal :value="showModal" width="40%" class-name="vertical-center-modal" @on-cancel="cancel">
      <div slot="header" class="title">
        <h2>增加频道</h2>
      </div>
      <div style="text-align:center" class="modifyRole">
        <i-row class="a-row">
          <i-col span="6" offset="1">
            <span>频道名称：</span>
          </i-col>
          <i-col :span="16">
            <i-input class="fontsize" v-model="insertName"></i-input>
          </i-col>
        </i-row>
        <i-row class="a-row">
          <i-col span="6" offset="1">
            <span class="title">简介：</span>
          </i-col>
          <i-col :span="16">
            <i-input class="fontsize" v-model="insertDesc"></i-input>
          </i-col>
        </i-row>
        <i-row class="a-row">
          <i-col span="6" offset="1">
            <span class="title">频道属性:</span>
          </i-col>
          <i-col :span="16">
            <i-select v-model="selectChannelAttr" @on-change="channelAttrChange" multiple class="tmp-select">
              <i-option v-for="(item, index) in attrList" :value="index" :label="item.name" :key="index">
                {{ item.name }}
              </i-option>
            </i-select>
          </i-col>
        </i-row>
        <div v-for="(item, index) in selectChannelAttr" :key="index">
          <i-row class="a-row" align="middle" v-if="attrList[item].type.split('__')[1] === 'string'">
            <i-col span="6" offset="1">
              <span class="text">{{ attrList[item].name }}：</span>
            </i-col>
            <i-col :span="16">
              <i-input class="col-input" type="text" v-model="channelAttrData[attrList[item].type]"></i-input>
            </i-col>
          </i-row>
          <i-row class="a-row" align="middle" v-if="attrList[item].type.split('__')[1] === 'textarea'">
            <i-col span="6" offset="1">
              <span class="text">{{ attrList[item].name }}：</span>
            </i-col>
            <i-col :span="16">
              <i-input
                class="col-input"
                type="textarea"
                :rows="4"
                v-model="channelAttrData[attrList[item].type]"
              ></i-input>
            </i-col>
          </i-row>
          <i-row class="a-row" align="middle" v-else-if="attrList[item].type.split('__')[1] === 'file'">
            <i-col span="6" offset="1">
              <span class="text">{{ attrList[item].name }}：</span>
            </i-col>
            <i-col :span="16">
              <input
                v-if="attrList[item].type.split('__')[2] === 'picture'"
                type="file"
                accept="image/*"
                @change="uploadFile($event, attrList[item].type.split('__')[2], attrList[item].type, channelAttrData)"
                :id="attrList[item].type"
              />
              <input
                v-if="attrList[item].type.split('__')[2] === 'video'"
                type="file"
                accept="video/*"
                @change="uploadFile($event, attrList[item].type.split('__')[2], attrList[item].type, channelAttrData)"
                :id="attrList[item].type"
              />
              <input
                v-if="attrList[item].type.split('__')[2] === 'pdf'"
                type="file"
                accept=".pdf"
                @change="uploadFile($event, attrList[item].type.split('__')[2], attrList[item].type, channelAttrData)"
                :id="attrList[item].type"
              />
            </i-col>
          </i-row>
          <i-row class="a-row" align="middle" v-if="attrList[item].type.split('__')[1].indexOf('enum') !== -1">
            <i-col span="6" offset="1">
              <span class="text">{{ attrList[item].name }}：</span>
            </i-col>
            <i-col :span="16">
              <i-select v-model="channelAttrData[attrList[item].type]" filterable>
                <i-option v-for="(_item, index) in attrList[item].value" :value="_item" :key="index">
                  {{ _item }}
                </i-option>
              </i-select>
            </i-col>
          </i-row>
        </div>
        <i-row class="a-row">
          <i-col span="6" offset="1">
            <span class="title">属性:</span>
          </i-col>
          <i-col :span="16">
            <i-select v-model="selectAttr" multiple class="tmp-select">
              <i-option v-for="(item, index) in attrList" :value="item.id" :label="item.name" :key="index">
                {{ item.name }}
              </i-option>
            </i-select>
          </i-col>
        </i-row>
        <i-row class="a-row">
          <i-col span="6" offset="1">
            <span class="title">可用模板:</span>
          </i-col>
          <i-col :span="16">
            <i-select v-model="insertTemp" multiple class="tmp-select">
              <i-option v-for="(item, index) in templateData" :value="item.id" :key="index">{{ item.name }}</i-option>
            </i-select>
          </i-col>
        </i-row>
        <i-row class="a-row">
          <i-col span="6" offset="1">
            <span class="title">允许新增和删除：</span>
          </i-col>
          <i-col :span="16">
            <i-switch v-model="allowCreate" />
            {{ allowCreate ? "是" : "否" }}
          </i-col>
        </i-row>
        <i-row class="a-row">
          <i-col span="6" offset="1">
            <span class="title">单文章频道：</span>
          </i-col>
          <i-col :span="16">
            <i-switch v-model="isArticle" />
            {{ isArticle ? "是" : "否" }}
          </i-col>
        </i-row>
        <i-row class="a-row">
          <i-col span="6" offset="1">
            <span class="title">是否允许自由编辑：</span>
          </i-col>
          <i-col :span="16">
            <i-switch v-model="insertFree" />
            {{ insertFree ? "是" : "否" }}
          </i-col>
        </i-row>
        <i-row class="a-row">
          <i-col span="6" offset="1">
            <span class="title">是否禁用：</span>
          </i-col>
          <i-col :span="16">
            <i-switch v-model="insertDisable" />
            {{ insertDisable ? "是" : "否" }}
          </i-col>
        </i-row>
      </div>
      <div slot="footer" style="text-align:center">
        <i-button type="primary" size="large" style="width:200px" @click="submitAdd">确认</i-button>
      </div>
    </i-modal>
  </div>
</template>

<script>
import { baseConfigMixin, uploadFileMixin } from "../mixin"

export default {
  data() {
    return {
      templateData: [],
      insertName: "",
      insertDesc: "",
      insertTemp: [],
      allowCreate: true,
      isArticle: false,
      insertFree: false,
      insertDisable: false,
      attrList: [],
      selectAttr: [],
      selectChannelAttr: [], // attrList里对应频道属性的index
      channelAttrList: [], // 频道属性的id
      channelAttr: {},
      imageLoading: false,
      channelMap: {},
      channelAttrData: {}, //存放所有的属性
    }
  },
  mixins: [baseConfigMixin, uploadFileMixin],
  props: {
    showModal: {
      type: Boolean,
    },
  },
  methods: {
    cancel() {
      this.reset()
      this.$emit("cancelModal")
    },
    reset() {
      this.insertName = ""
      this.insertDesc = ""
      this.insertTemp = []
      this.allowCreate = true
      this.isArticle = false
      this.insertFree = false
      this.insertDisable = false
      this.selectAttr = []
      this.selectChannelAttr = []
      this.channelAttrList = []
      this.channelAttr = {}
      this.imageLoading = false
      this.channelAttrData = {}
    },
    channelAttrChange() {
      let initChannelAttr = {}
      const self = this
      this.selectChannelAttr.forEach((item) => {
        initChannelAttr[self.attrList[item].type] = ""
      })
      Object.keys(this.channelAttrData).forEach((item) => {
        if (Object.keys(initChannelAttr).indexOf(item) !== -1) {
          initChannelAttr[item] = self.channelAttrData[item]
        } else {
          self.channelAttrData[item] = ""
        }
      })
    },
    async submitAdd() {
      const self = this
      if (this.insertName === "") {
        this.$Message.error("频道名称不能为空")
        return
      }
      if (this.imageLoading) {
        this.$Message.error("请等待文件上传完成！")
        return
      }
      this.channelAttr = {}
      this.selectChannelAttr.forEach((item) => {
        self.channelAttrList.push(self.attrList[item].id)
        self.channelAttr[self.attrList[item].type] = self.channelAttrData[self.attrList[item].type]
      })
      for (let item in this.channelAttr) {
        if (this.channelAttr[item] === "") {
          self.$Message.error("请填写" + this.channelMap[item] + "!")
          return
        }
      }
      const res = await this.axios({
        method: "post",
        url: this.cmsUrl + "api/content/channel/add",
        data: {
          name: this.insertName,
          channel_attributes: this.channelAttrList,
          channel_attr_data: this.channelAttr,
          desc: this.insertDesc,
          templates: this.insertTemp,
          attributes: this.selectAttr,
          allow_create: this.allowCreate ? 1 : 0,
          is_article: this.isArticle ? 1 : 0,
          is_free_edit: this.insertFree ? 1 : 0,
          disable: this.insertDisable ? 1 : 0,
        },
      })
      if (!res) {
        return
      }
      if (res.data.code === 0) {
        this.$Message.success("添加成功")
        this.reset()
        this.$emit("success")
        this.cancel()
      } else {
        this.showLoading = false
        this.$Message.error("操作失败，错误原因：" + res.data.error_message)
      }
    },
    //获取模板信息
    async getTemp() {
      let self = this
      self.showLoading = true
      try {
        const res = await self.axios({
          method: "get",
          url: this.cmsUrl + "api/content/template/list",
        })
        if (!res) {
          return
        }
        if (res.data.code === 0) {
          self.showLoading = false
          this.templateData = res.data.data.data
        } else {
          self.showLoading = false
          self.$Message.error("获取模板操作失败，错误原因：" + res.data.error_message)
          console.log(res)
        }
      } catch (err) {
        self.showLoading = false
        self.$Message.error("操作失败，错误原因：" + err)
        console.log(err)
      }
    },
    //获取属性信息
    async getAttr() {
      let self = this
      self.showLoading = true
      try {
        const res = await self.axios({
          method: "get",
          url: this.cmsUrl + "api/content/attribute/list",
        })
        if (!res) {
          return
        }
        if (res.data.code === 0) {
          self.showLoading = false
          this.attrList = []
          this.attrList.push(...res.data.data.data)
          res.data.data.data.forEach((item) => {
            self.channelMap[item.type] = item.name
            self.channelAttrData[item.type] = ""
          })
        } else {
          self.showLoading = false
          self.$Message.error("获取模板操作失败，错误原因：" + res.data.error_message)
          console.log(res)
        }
      } catch (err) {
        self.showLoading = false
        self.$Message.error("操作失败，错误原因：" + err)
        console.log(err)
      }
    },
  },
  async mounted() {
    await this.getTemp()
    await this.getAttr()
  },
}
</script>
<style scoped>
.title {
  text-align: center;
}
.a-row {
  margin: 15px 0 30px 0;
}
.tmp-select {
  text-align: left;
  min-width: 200px;
}
</style>
